import { Service } from "./Service";
import { WebPage } from "./WebPage";
import { toMap } from "../../../HA";

export class HorApp extends Service {

    public showApp(id: string): void {
        this.getPage().showApp(toMap({id}));
    }

    public toggleApp(id: string): void {
        this.getPage().toggleApp(toMap({id}));
    }

    public reloadApp(id: string): void {
        this.getPage().reloadApp(toMap({id}));
    }

    protected getPage(): any {
        return this.get("pages");
    }

    protected initialize(data: any): void {
        this.addToData("pages", new WebPage(data));
    }
}
